var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2079 12.8334H13.4838L13.2271 12.5859C14.3271 11.3026 14.8954 9.55175 14.5838 7.69092C14.1529 5.14259 12.0263 3.10759 9.4596 2.79592C5.5821 2.31925 2.31876 5.58258 2.79543 9.46008C3.1071 12.0268 5.1421 14.1534 7.69043 14.5843C9.55126 14.8959 11.3021 14.3276 12.5854 13.2276L12.8329 13.4843V14.2084L16.7288 18.1043C17.1046 18.4801 17.7188 18.4801 18.0946 18.1043C18.4704 17.7284 18.4704 17.1143 18.0946 16.7384L14.2079 12.8334ZM8.70793 12.8334C6.42543 12.8334 4.58293 10.9909 4.58293 8.70842C4.58293 6.42592 6.42543 4.58342 8.70793 4.58342C10.9904 4.58342 12.8329 6.42592 12.8329 8.70842C12.8329 10.9909 10.9904 12.8334 8.70793 12.8334Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.cce8e0a2eec3863767914e79dfa4bff5.svg";
export { ForwardRef as ReactComponent };